module.exports = __webpack_public_path__ + "static/img/aepic-4.c0d281a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-4.jpg
// module id = GYUE
// module chunks = 51